import { Button, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, Heading, Text } from "@sentricmusic/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import useGetColours from "@/helpers/getColours";
import { useUIStateStore } from "@/store/uiStateStore";

type SingleWriterWarningModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function SingleWriterWarningModal({
  isOpen,
  onClose,
  onConfirm,
}: SingleWriterWarningModalProps) {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const { t } = useTranslation(["songs", "common"]);
  const { highlightColour } = useGetColours();

  const handleConfirm = () => {
    if (doNotShowAgain) {
      localStorage.setItem("showWriterWarning", "false");
    }
    onConfirm();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <div className={`flex flex-col justify-between min-h-80 sm:min-h-48 ${
          isTunecore ? "text-white" : "text-black font-sentric"
        }`}
        >
          <DialogHeader className="mb-6 text-left">
            <DialogTitle asChild>
              <Heading as="h3" className="mb-4">
                {t("songs:single-writer-warning-header")}
              </Heading>
            </DialogTitle>
            <DialogDescription asChild>
              <Text as="p">
                {t("songs:single-writer-warning-description")}
              </Text>
            </DialogDescription>
          </DialogHeader>

          <div className="mb-6">
            <input
              style={{
                accentColor: highlightColour,
              }}
              type="checkbox"
              className={`mr-3 lg:scale-125 ${
                isTunecore ? "text-blue-600" : ""
              }`}
              id="doNotShowAgain"
              checked={doNotShowAgain}
              onChange={() => setDoNotShowAgain(!doNotShowAgain)}
            />
            <label htmlFor="doNotShowAgain">
              {t("common:dont-show-again")}
            </label>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <Button
            variant="outline"
            onClick={onClose}
            label={t("common:take-me-back-button")}
          />
          <Button
            variant={isTunecore ? "secondary" : "primary"}
            onClick={handleConfirm}
            label={t("common:i-understand-button")}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
